import { render, staticRenderFns } from "./ssiv.vue?vue&type=template&id=65b3eb14"
import script from "./ssiv.vue?vue&type=script&lang=js"
export * from "./ssiv.vue?vue&type=script&lang=js"
import style0 from "./ssiv.vue?vue&type=style&index=0&id=65b3eb14&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports